<template>
  <g>
    <path :style="styles.path" :d="pathD"></path>
    <circle
      v-for="(p, index) in pointsPositions"
      :key="'l' + index"
      :cx="p[0]"
      :cy="p[1]"
      r="2.5"
      :style="styles.circles"
    />
  </g>
</template>

<script>
const lib = {
  map(value, inMin, inMax, outMin, outMax) {
    return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
  },
  range(start, end, tick) {
    const s = Math.round(start / tick) * tick;
    return Array.from(
      {
        length: Math.floor((end - start) / tick)
      },
      (v, k) => {
        return k * tick + s;
      }
    );
  }
};

export default {
  props: {
    d: { type: Object, default: null },
    o: { type: Object, default: null },
    svg: { type: Object, default: null },
    points: { type: Array, default: null }
  },
  computed: {
    styles() {
      return {
        path: {
          fill: this.d.colors.path,
          stroke: this.d.colors.path,
          strokeWidth: 2,
          fillOpacity: 0.9,
          strokeOpacity: 1
        },
        circles: {
          fill: this.d.colors.circles
        }
      };
    },
    pathD() {
      return this.pointsPositions.reduce(
        (acc, e, i, a) =>
          i === 0
            ? `M ${a[a.length - 1][0]},${this.svg.h}
L ${e[0]},${this.svg.h} L ${e[0]},${e[1]}`
            : `${acc} ${this.bezierCommand(e, i, a)}`,
        ''
      );
    },
    pointsPositions() {
      // console.log('points position', this.points);

      if (this.points === '0') return;

      return this.points.map(e => {
        const x = lib.map(e[0], this.o.xMin, this.o.xMax, 0, this.svg.w);
        const y = lib.map(e[1], this.o.yMin, this.o.yMax, this.svg.h, 0);
        return [x, y];
      });
    }
  },
  mounted: function() {
    // console.log('svg lines:', this.points);
    // if (!this.points) return;
    // this.points.map(item => {
    //   console.log(item);
    // });
  },
  methods: {
    line(pointA, pointB) {
      const lengthX = pointB[0] - pointA[0];
      const lengthY = pointB[1] - pointA[1];
      return {
        length: Math.sqrt(Math.pow(lengthX, 2) + Math.pow(lengthY, 2)),
        angle: Math.atan2(lengthY, lengthX)
      };
    },
    controlPoint(current, previous, next, reverse) {
      const p = previous || current;
      const n = next || current;
      const o = this.line(p, n);
      // work in progress…
      const flat = lib.map(
        Math.cos(o.angle) * this.o.line.flattening,
        0,
        1,
        1,
        0
      );
      const angle = o.angle * flat + (reverse ? Math.PI : 0);
      const length = o.length * this.o.line.smoothing;
      const x = current[0] + Math.cos(angle) * length;
      const y = current[1] + Math.sin(angle) * length;
      return [x, y];
    },
    bezierCommand(point, i, a) {
      const cps = this.controlPoint(a[i - 1], a[i - 2], point);
      const cpe = this.controlPoint(point, a[i - 1], a[i + 1], true);
      const close = i === a.length - 1 ? ' z' : '';
      return `C ${cps[0]},${cps[1]} ${cpe[0]},${cpe[1]} ${point[0]},${
        point[1]
      }${close}`;
    }
  }
};
</script>

<style scoped></style>
